import React from "react";
import { Button, Input, Label, Badge } from "reactstrap";
import IntlMessages from "Util/IntlMessages";
import { LAYOUT_SELECT_SM_WIDTH } from "Constants/reactifyInlineStyles";

type MockPaginationFooterProps = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (p: number) => void;
  onPageSizeChange?: (n: number) => void;
  pageSizeOptions?: number[];
};

export default function MockPaginationFooter({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 25]
}: MockPaginationFooterProps) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3 pt-3 border-top">
      <p className="text-muted small mb-0">
        <IntlMessages id="suite.mock.pagination-range" />{" "}
        <strong>
          {start}–{end}
        </strong>{" "}
        <IntlMessages id="suite.mock.pagination-of" />{" "}
        <strong>{total}</strong>
        <Badge color="light" className="ms-2 text-dark">
          <IntlMessages id="suite.mock.pagination-label" />
        </Badge>
      </p>
      <div className="d-flex flex-wrap align-items-center gap-2">
        {onPageSizeChange && (
          <div className="d-flex align-items-center gap-1">
            <Label className="small text-muted mb-0 me-1">
              <IntlMessages id="suite.mock.page-size" />
            </Label>
            <Input
              type="select"
              bsSize="sm"
              style={LAYOUT_SELECT_SM_WIDTH}
              value={String(pageSize)}
              onChange={e => onPageSizeChange(Number(e.target.value))}
            >
              {pageSizeOptions.map(n => (
                <option key={n} value={String(n)}>
                  {n}
                </option>
              ))}
            </Input>
          </div>
        )}
        <Button
          size="sm"
          color="light"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          ←
        </Button>
        <span className="small text-muted">
          {page} / {pages}
        </span>
        <Button
          size="sm"
          color="light"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        >
          →
        </Button>
      </div>
    </div>
  );
}
